import React from 'react'
import { Avatar } from 'antd'
import { NavLink } from 'react-router-dom'

import { NAV_LINK_NAMES } from 'shared/consts'
import { useAvatar } from 'shared/avatar'

import s from './ProfileLabel.module.scss'

type ProfileLabelProps = {
    name: string
}

/**
 * Лейбл пункта «профиль» в Header — аватарка (PFP) + имя/адрес.
 * Аватарка реактивна: при смене на странице Account обновляется и тут
 * (см. useAvatar / rc-avatar-change event).
 */
export const ProfileLabel: React.FC<ProfileLabelProps> = React.memo(
    ({ name }) => {
        const { avatarUrl } = useAvatar()

        return (
            <NavLink to={NAV_LINK_NAMES.ACCOUNT} className={s.wrapper}>
                <Avatar src={avatarUrl} size={34} className={s.avatar} />
                <span className={s.name}>{name}</span>
            </NavLink>
        )
    }
)
